import type { ChatMessage } from '@/hooks/useMessages';

/** Normaliza IDs de SQL Server (a veces llegan como string). */
export function messageBelongsToThread(
  message: ChatMessage,
  currentCharId: number,
  otherCharId: number,
): boolean {
  const sender = Number(message.sender_CharID);
  const receiver = Number(message.receiver_CharID);
  if (!sender || !receiver || !currentCharId || !otherCharId) return false;
  return (
    (sender === currentCharId && receiver === otherCharId) ||
    (sender === otherCharId && receiver === currentCharId)
  );
}

export function filterThreadMessages(
  messages: ChatMessage[],
  currentCharId: number,
  otherCharId: number,
): ChatMessage[] {
  return messages.filter((m) => messageBelongsToThread(m, currentCharId, otherCharId));
}
